import React from 'react';
import { FaBook, FaBuilding, FaClipboardList, FaFileAlt, FaGraduationCap, FaLayerGroup, FaListAlt, FaQuestionCircle, FaUserEdit, FaUsers } from 'react-icons/fa';
import { MdApartment, MdComputer, MdOutlineContentPaste, MdPrint, MdRateReview } from 'react-icons/md';
import './PageHeading.css';

const icons = {
    institutions: MdApartment,
    disciplines: FaBook,
    questions: FaListAlt,
    questionnaires: FaQuestionCircle,
    authors: FaUserEdit,
    demands: FaClipboardList,
    appeals: FaFileAlt,
    review: MdRateReview,
    organizations: FaBuilding,
    members: FaUsers,
    system: MdComputer,
    training: FaGraduationCap,
    modules: FaLayerGroup,
    contents: MdOutlineContentPaste,
    layouts: MdPrint,
};

export default function PageHeading({ title, description, icon, leading }) {
    const Icon = icons[icon] || FaListAlt;
    return <div className="admin-page-heading hidethis">
        {leading || <span className="admin-page-heading-icon hidethis" aria-hidden="true"><Icon /></span>}
        <div className="admin-page-heading-text hidethis">
            <h1 className="admin-page-heading-title hidethis">{title}</h1>
            <p className="admin-page-heading-description hidethis">{description}</p>
        </div>
    </div>;
}
